module.exports = __webpack_public_path__ + "img/imgsendcardbt.e4359054.png";